(function () {
  'use strict';

  function initialiseFilters(scope) {
    var panel = (scope || document).querySelector('.ew-filter-panel');
    if (!panel) return;

    var groups = panel.querySelectorAll('.filterBox');
    groups.forEach(function (group) {
      var title = group.querySelector('.widget-title');
      if (!title) return;

      var hasSelection = !!group.querySelector('input:checked');
      var isPrice = group.classList.contains('flPrice');
      var titleText = (title.textContent || '').trim().toLowerCase();
      var isApplication = titleText === 'toepassing';
      var query = new URLSearchParams(window.location.search);
      var hasPriceSelection = isPrice && (
        query.has('filter.v.price.gte') || query.has('filter.v.price.lte')
      );
      if (isApplication || hasSelection || hasPriceSelection) group.classList.remove('ew-collapsed');
      else group.classList.add('ew-collapsed');

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', String(!group.classList.contains('ew-collapsed')));

      function toggleGroup() {
        group.classList.toggle('ew-collapsed');
        title.setAttribute('aria-expanded', String(!group.classList.contains('ew-collapsed')));
      }

      if (group.dataset.ewReady !== 'true') {
        title.addEventListener('click', toggleGroup);
        title.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleGroup();
          }
        });
        group.dataset.ewReady = 'true';
      }
    });

    panel.querySelectorAll('.flPrice').forEach(function (priceGroup) {
      if (priceGroup.dataset.ewPriceReady === 'true') return;
      var minInput = panel.querySelector('input[name="filter.v.price.gte"]');
      var maxInput = panel.querySelector('input[name="filter.v.price.lte"]');
      var presets = priceGroup.querySelectorAll('.ew-price-preset');
      if (!minInput || !maxInput || !presets.length) return;

      function markActive() {
        var low = Number(minInput.value) || 0;
        var high = Number(maxInput.value) || Number(maxInput.max);
        presets.forEach(function (preset) {
          var active = low === Number(preset.dataset.min) && high === Number(preset.dataset.max);
          preset.classList.toggle('is-active', active);
          preset.setAttribute('aria-pressed', String(active));
        });
      }

      presets.forEach(function (preset) {
        preset.addEventListener('click', function () {
          var wasActive = preset.classList.contains('is-active');
          minInput.value = wasActive ? 0 : preset.dataset.min;
          maxInput.value = wasActive ? maxInput.max : preset.dataset.max;
          markActive();
          maxInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      minInput.addEventListener('input', markActive);
      maxInput.addEventListener('input', markActive);
      markActive();
      priceGroup.dataset.ewPriceReady = 'true';
    });

    updateResultButton();
  }

  function updateResultButton() {
    var button = document.querySelector('.ew-filter-results');
    var counter = document.querySelector('.filters-toolbar__product-count, [data-product-count], .product-count');
    if (!button || !counter) return;

    var numbers = (counter.textContent || '').match(/\d[\d.,]*/g);
    if (!numbers || !numbers.length) return;

    var count = numbers[numbers.length - 1].replace(/[^\d]/g, '');
    if (!count) return;

    var label = button.getAttribute('data-result-label') || 'Bekijk [count] resultaten';
    var nextText = label.replace('[count]', count);
    if (button.textContent !== nextText) button.textContent = nextText;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseFilters(document); });
  } else {
    initialiseFilters(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseFilters(event.target);
  });

  if (document.body && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      window.setTimeout(function () {
        initialiseFilters(document);
        updateResultButton();
      }, 0);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* Compatibility hook used by Avone after an AJAX filter refresh. */
  window.priceSlider = function () {
    window.setTimeout(function () {
      initialiseFilters(document);
      updateResultButton();
    }, 0);
  };
}());
